export default __webpack_public_path__ + "static/media/img_introduce_bottom_banner.46ea65f4.png";